import React from 'react';
import { cx } from '../shared/ui/utils';

const ThemeChips = ({ themes = [], activeThemes = [], onToggle }) => {
  if (!themes.length) return null;
  return (
    <div className="flex flex-wrap gap-2">
      {themes.map((theme) => {
        const value = theme.slug || String(theme.id);
        const active = activeThemes.includes(value);
        return (
          <button
            key={value}
            type="button"
            onClick={() => onToggle(value)}
            className={cx(
              'rounded-full border px-4 py-2 text-xs font-semibold uppercase tracking-[0.2em]',
              active
                ? 'border-amber-500 bg-amber-100 text-amber-900'
                : 'border-slate-200 text-slate-600 hover:border-slate-300'
            )}
          >
            {theme.name}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeChips;
